<template>
  <div>
    <div class="achievements_cat">
      <h1>{{ categoryValue }}</h1>
    </div>
    <div class="achievements_icons">
      <achievement v-for="(achievement, index) in achievements"
                   v-if="index < page*3"
                   :achievement-info="achievement"
                   :category-name="category | categoryNameFilter"
                   :achievement-index="index"
                   :key="index"/>
      <div class="achievements_btn">
        <a href="#"
           v-if="hasMore"
           @click.prevent="loadMore()"
           class="load-more btn2 btn2--std btn2--small btn2--green">
          ···
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Achievement from '@/components/home/achievements/Achievement';

export default {
  name: 'achievement-category',
  props: {
    category: String,
    categoryValue: String,
    achievements: Array,
  },
  components: {
    Achievement,
  },
  data() {
    return {
      page: 1,
    };
  },
  methods: {
    loadMore() {
      this.page = this.page + 1;
    },
  },
  computed: {
    hasMore() {
      return this.achievements.length > this.page * 3;
    },
  },
  filters: {
    categoryNameFilter(name) {
      return name.toLowerCase();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/achievements/AchievementCategory.vue